module.exports = __webpack_public_path__ + "assets/fonts/glyphicons-halflings-regular.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/fonts/glyphicons-halflings-regular.eot
 ** module id = 754
 ** module chunks = 1
 **/